import React from "react";
import {Table, Input, Button, Icon, Row, Col, Tooltip, message, Modal, Dropdown, Menu, Divider,Switch} from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import NHTable from '../../common/NHTable';
import {NHModal, NHConfirm} from '../../common/NHModal';
import {hasAuth,getLoginUser} from "../../../utils/NHCore";
import NHContainerFrame from '../../common/NHContainerFrame';
import EditForm from './EditForm.js';
import ViewForm from './ViewForm';
import css from './index.css';
import YlhjpzForm from './YlhjpzForm';  //依赖环节配置
import QztjpzForm from './QztjpzForm';  //前置条件配置
import moment from 'moment';

const confirm = Modal.confirm;
const dateFormat = 'YYYY-MM-DD HH:mm:ss';
const baseUrlPath = "/fwwgl/zzbd"; //TODO 把此处的信息改成自己的

class Zzbd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},
            isAdd:true,
            showButton:false,
            frameVisibleMap:{
                tableFlag:true,
                addFlag:false,
                ylhjpzFlag:false,
                qztjpzFlag:false,
                updateFlag:false,
                viewFlag:false,
            },
            getPcbltsContent:undefined,
            getYdbltsContent:undefined,
        };
    }

    getPcbltsContent=(getContent)=>{
        this.setState({getPcbltsContent:getContent});
    }
    getYdbltsContent=(getContent)=>{
        this.setState({getYdbltsContent:getContent});
    }


    //设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap=this.state.frameVisibleMap;
        for(let name in frameVisibleMap){
            if(name==showFlagName){
                frameVisibleMap[name]=true;
            }else{
                frameVisibleMap[name]=false;
            }
        }
        this.setState({
            frameVisibleMap:frameVisibleMap
        });
    }

    //新增按钮点击事件
    handleAddBtnClick1 = () => {
        this.setState({ isAdd: true });
        this.setCurrentPageShow('addFlag');
    }

    handleAddBtnClick2 = () => {
        this.setCurrentPageShow('ylhjpzFlag');
    }

    handleAddBtnClick3 = () => {
        this.setCurrentPageShow('qztjpzFlag');
    }
    //修改按钮点击事件
    handleUpdateBtnClick = (record) => {
        let pkid = record.PKID;//TODO 把此处的信息改成自己的
        NHFetch(baseUrlPath + '/' + pkid + '/get', 'GET')
            .then(res => {
                if(res){
                    this.setState({formInitData: res.data});
                    this.setState({ isAdd: false });
                    this.setCurrentPageShow('updateFlag');
                }
            })
    }
   
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
    }

    //单行删除
    handleSingleDeleteBtnClick = (record) => {
       NHConfirm("是否确定删除这条数据？",() => {
           let pkid = record.PKID;//TODO 把此处的信息改成自己的
           this.handleDelete([pkid]);
       },"warn");
    }
    //多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        if(selectedRowKeys && selectedRowKeys.length>0){
            NHConfirm("是否确定删除选中的多条数据？",() => {
                this.handleDelete(selectedRowKeys);
            },"warn");
        }else{
            message.warning("请先选择需要删除的数据！");
        }
    }
    //删除操作
    handleDelete = (pkids) => {
        NHFetch(baseUrlPath + '/deleteByMulti' , 'POST' , pkids)
            .then(res => {
                if (res) {
                    message.success("删除操作成功！");
                    this.refs.nhTable.filterTableData();
                }
            })
    }

    updateState = (record) => {
        NHFetch(baseUrlPath+"/insertOrUpdate","POST",{"pkid":record.PKID,"zt":record.ZT == '1' ? '0' : '1'})
            .then(res => {
                if (res && res.code == 200) {
                    message.success("操作成功");
                }else{
                    message.warn("操作异常");
                }
                this.refs.nhTable.readTableData();
            });
    }
    //新增 or 修改面板保存方法
    handleSaveAddOrUpdate = () => {
        this.refs.nhAddForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            if(formData.kssj >= formData.jssj){
                message.warning('开始时间不能大于结束时间');
                return;
            }
            let kssj = moment(formData.kssj).format(dateFormat);
            let jssj = moment(formData.jssj).format(dateFormat);
            formData.kssj = kssj;
            formData.jssj = jssj;   
            formData.zt = formData.zt ? '1' : '0';
            let msg = "";
            if(!this.state.isAdd){
                formData.pkid = this.state.formInitData.pkid;
                msg = "修改成功！";
            }else{
                msg = "新增成功！";
            }
            let data =  formData ;          
            data['ydblts'] = this.state.getYdbltsContent();
            data['pcblts'] = this.state.getPcbltsContent();
            NHFetch(baseUrlPath + '/insertOrUpdate' , 'POST' , formData)
                .then(res => {
                    if (res) {
                        message.success(msg);
                        this.setCurrentPageShow('tableFlag');
                        this.refs.nhTable.filterTableData();
                    }
                })
        });
    }

    saveZzbdYlhj = () => {
        this.refs.nhYlhjpzSet.validateFields((err, formData) => {
            if (err) {
                return;
            }


            NHFetch(baseUrlPath + '/batchInsertYlhj', 'post', formData).then(res => {
                if (res) {
                    message.success("设置成功！");
                    this.setCurrentPageShow('tableFlag');
                    this.setState({showOperationBtn: false});
                    this.refs.nhTable.filterTableData();
                }
            });
        });
    }

    saveZzbdQztj = () => {
        this.refs.nhQztjpzSet.validateFields((err, formData) => {
            if (err) {
                return;
            }
            NHFetch(baseUrlPath + '/batchInsertQztj', 'post', formData).then(res => {
                if (res) {
                    message.success("设置成功！");
                    this.setCurrentPageShow('tableFlag');
                    this.setState({showOperationBtn: false});
                    this.refs.nhTable.filterTableData();
                }
            });
        });
    }

    handleViewBtnClick = (record) => {
        this.setState({
            formInitData: record
        },this.setCurrentPageShow('viewFlag'));
    };

    rowSelectionChange = (selectedRowKeys) => {
        if (selectedRowKeys.length) {
            this.setState({
                showButton: true
            })
        } else {
            this.setState({
                showButton: false
            })
        }
    }
   
    render() {
        //列参数
        const columns = [
            {
                title: '序号',
                width: '60px',
                dataIndex: 'ROW_ID'
            }, {
                title: '环节名称',
                width: '150px',
                dataIndex: 'HJMC',
                searchType:"input"
            }, {
                title: '类型',
                width: '100px',
                dataIndex: 'HJLXMC',
                searchType:"select"
            }, {
                title: '环节代码',
                width: '100px',
                dataIndex: 'HJDM',
                searchType:"input"
            },
            {
                title: '排序号',
                width: '60px',
                dataIndex: 'pxh',
                searchType:"input"
            },
            {
                title: '状态',
                width: '60px',
                dataIndex: 'ZTMC',
                render:(text,record,index) => {
                    const status = record.ZT=='1' ? true:false;
                    return (
                        hasAuth('zhxg_yxgl_fwwgl_zzbd:update_state') ?
                        <Switch checkedChildren="启用" unCheckedChildren="停用" checked={status} onChange={() => this.updateState(record)}/>
                        : <Switch checkedChildren="启用" unCheckedChildren="停用" checked={status} disabled={true}/>
                    );
                }
            },{
                title: '开始时间',
                width: '100px',
                dataIndex: 'KSSJ',
                searchType:"datetime"
            },{
                title: '结束时间',
                width: '100px',
                dataIndex: 'JSSJ',
                searchType:"datetime"
            }
        ];
        //行内操作
        const action = [
            {title: '查看', onClick: this.handleViewBtnClick, auth: 'zhxg_yxgl_fwwgl_zzbd:detail'},
            {title: '修改', onClick: this.handleUpdateBtnClick, auth: 'zhxg_yxgl_fwwgl_zzbd:update'},
            {title: '删除', onClick: this.handleSingleDeleteBtnClick, auth: 'zhxg_yxgl_fwwgl_zzbd:delete'}
        ];
        return (
            <div className={css.main_right_content} style={{height:getSize().windowH-163}}>
                <div className={css.table} style={{display:this.state.frameVisibleMap.tableFlag?'block':'none'}}>
                    <NHTable ref='nhTable'
                             rowKey={record =>record.PKID} //TODO 把此处的信息改成自己的
                             sign={"zhxg_yxxt_fwwgl_zzbd_queryPage"} //TODO 把此处的信息改成自己的
                             rowSelectionChange={this.rowSelectionChange}
                             columns={columns}
                             action={action}
                    >
                        {hasAuth('zhxg_yxgl_fwwgl_zzbd:add')? <Button type="primary" onClick={this.handleAddBtnClick1}>新增</Button> : null}
                        {hasAuth('zhxg_yxgl_fwwgl_zzbd:addYlhj')? <Button type="primary" ghost style={{marginLeft: 10}} onClick={this.handleAddBtnClick2}>依赖环节设置</Button> : null}
                        {hasAuth('zhxg_yxgl_fwwgl_zzbd:addQztj')? <Button type="primary" ghost style={{marginLeft: 10}} onClick={this.handleAddBtnClick3}>前置条件设置</Button> : null}
                        {hasAuth('zhxg_yxgl_fwwgl_zzbd:multiDelete')? <Button type="danger" ghost style={{marginLeft:10, display: this.state.showButton ? undefined : 'none'}} onClick={this.handleMultiDeleteBtnClick}>删除</Button> : null}
                    </NHTable>
                </div>
                <NHContainerFrame ref="nhAddModal"
                         title="新增自助报到" //TODO 把此处的信息改成自己的
                         visible={this.state.frameVisibleMap.addFlag}
                         onOk={this.handleSaveAddOrUpdate}
                         onCancel={this.handleCloseFrame}
                >
                    <EditForm ref="nhAddForm" getPcbltsContent={this.getPcbltsContent} getYdbltsContent={this.getYdbltsContent} />
                </NHContainerFrame>

                <NHContainerFrame ref="nhUpdateModal"
                         title="修改自助报到" //TODO 把此处的信息改成自己的
                         visible={this.state.frameVisibleMap.updateFlag}
                         onOk={this.handleSaveAddOrUpdate}
                         onCancel={this.handleCloseFrame}
                >
                    <EditForm ref="nhAddForm" getPcbltsContent={this.getPcbltsContent} getYdbltsContent={this.getYdbltsContent} initFormData={this.state.formInitData}/>
                </NHContainerFrame>

                <NHContainerFrame ref="nhShowModal"
                                  visible={this.state.frameVisibleMap.viewFlag}
                                  title="查看详情"
                                  footer={null}
                                  onCancel={this.handleCloseFrame}>
                    <ViewForm initViewFormData={this.state.formInitData}/>
                </NHContainerFrame>

                <NHContainerFrame ref="nhylhjpzModal"
                         title="配置依赖环节" //TODO 把此处的信息改成自己的
                         visible={this.state.frameVisibleMap.ylhjpzFlag}
                         onOk={this.saveZzbdYlhj}
                         onCancel={this.handleCloseFrame}
                >
                     <YlhjpzForm ref="nhYlhjpzSet" initFormData={this.state.formInitData} />
                </NHContainerFrame>

                <NHContainerFrame ref="nhqztjpzModal"
                         title="配置前置条件" //TODO 把此处的信息改成自己的
                         visible={this.state.frameVisibleMap.qztjpzFlag}
                         onOk={this.saveZzbdQztj}
                         onCancel={this.handleCloseFrame}
                >
                     <QztjpzForm ref="nhQztjpzSet" initFormData={this.state.formInitData} />
                </NHContainerFrame>
            </div>
        );
    }
}
export default Zzbd;



// WEBPACK FOOTER //
// ./components/fwwgl/zzbd/index.js